import { Flex, Radio, Text } from "@chakra-ui/react";
import { ReactElement } from "react";

type CheckboxCardProps = {
  title: string | ReactElement,
  subtitle?: string | ReactElement,
  amount?: number,
  label?: string,
  icons?: ReactElement,
  isChecked: boolean,
  onChange: any;
};

const CheckboxCard = ({ title, subtitle, amount, label, icons, isChecked, onChange }: CheckboxCardProps) => {
  return (<Flex
    padding={[4, 4, 6, 8]}
    justifyContent='space-between'
    marginBottom={5}
    boxShadow="0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)"
    borderRadius={[30, 50, 70, 100]}>
    <Flex flexDirection='column'>
      <Flex flexDirection='row'
        justifyContent='center' alignItems='center'>
        <Text fontWeight={500} fontSize="16px" fontFamily="Montserrat">
          {title}
        </Text>
        {icons}
      </Flex>
      <Text fontWeight={400} fontSize="12px" fontFamily="Montserrat">
        {subtitle}
      </Text>
    </Flex>
    <Flex justifyContent='space-between' align='center'>
      {amount &&
        <Text fontWeight={500} fontSize="16px" fontFamily="Montserrat">
          ${amount}
        </Text>}
      <Radio isChecked={isChecked} paddingLeft={5}
        onChange={(e) => onChange(label, e.target.checked)} />
    </Flex>
  </Flex>);
};

export { CheckboxCard };